
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/africa/speakers/profile/[slug]",
      function () {
        return require("private-next-pages/africa/speakers/profile/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/africa/speakers/profile/[slug]"])
      });
    }
  